const includesBeta = () => import.meta.env.VUE_APP_BASE_URL.includes('console.beta')

/**
 * Application mode configuration object that provides various environment checks
 * @namespace
 */
const appMode = {
  /**
   * Checks if the application is running in development mode
   * @returns {boolean} True if MODE starts with 'dev'
   */
  get isDev () {
    return import.meta.env.MODE.startsWith('dev')
  },

  /**
   * Checks if the application is running in staging environment
   * @returns {boolean} True if MODE is 'staging'
   */
  get isStaging () {
    return import.meta.env.MODE === 'staging'
  },

  /**
   * Checks if the application is running in production environment
   * @returns {boolean} True if MODE is 'production'
   */
  get isProduction () {
    return import.meta.env.MODE === 'production'
  },

  /**
   * Checks if the application is running in beta mode on staging
   * @returns {boolean} True if environment is staging and host contains beta
   */
  get isBeta () {
    return this.isStaging && includesBeta()
  },

  /**
   * Checks if the application is running in an e-env (i.e. PRs)
   * @returns {boolean} True if host starts with the e-env prefix (or console-pr- as fallback)
   */
  get isEEnv () {
    // TODO: remove fallback when all PRs will use VUE_APP_EENV_PREFIX
    return location.host.startsWith(import.meta.env.VUE_APP_EENV_PREFIX ?? 'console-pr-')
  },

  /**
   * Checks if the application is running in either development or staging
   * @returns {boolean} True if environment is dev or staging
   */
  get isStagingOrDev () {
    return this.isDev || this.isStaging
  },

  /**
   * Checks if the backend is running locally
   * @returns {boolean} True if API URL includes 'localhost'
   */
  get isLocalBE () {
    return import.meta.env.VUE_APP_API_URL.includes('localhost')
  },

  /**
   * Checks if the application is running in test mode
   * @returns {boolean} True if MODE is 'test'
   */
  get isTest () {
    return import.meta.env.MODE === 'test'
  },
}
export { appMode }
